import { Catalogue } from './Catalogue.interface';

export class CatalogueModel implements Catalogue {
  id?: number;
  type: 'biznes' | 'uslugi';
  rootCategories: number[];

  constructor(data: any, categories: number[]) {
    this.id = data.id ? data.id : null;
    this.type =
      data.type && (data.type === 'biznes' || data.type === 'uslugi')
        ? data.type
        : 'uslugi';
    this.rootCategories = categories && categories.length ? categories : [];
  }
}
